import { createError } from 'lib/api/serverError'
import HTTPHandler, { formatResponse } from 'lib/api/HTTPHandler'
import { CS_API_URL } from '../env'

export class OktellService {
  static getResultByPhone = async phone => {
    try {
      const res = await HTTPHandler.get(
        CS_API_URL + '/oktell/getResultByPhone/' + phone
      )
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }
}

export default OktellService
